import S from "./index.es516.js";
function a(r) {
  "@babel/helpers - typeof";
  return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, a(r);
}
function y(r, t) {
  var e = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    t && (n = n.filter(function(l) {
      return Object.getOwnPropertyDescriptor(r, l).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function i(r) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? y(Object(e), !0).forEach(function(n) {
      d(r, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : y(Object(e)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }
  return r;
}
function d(r, t, e) {
  return (t = O(t)) in r ? Object.defineProperty(r, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = e, r;
}
function O(r) {
  var t = h(r, "string");
  return a(t) == "symbol" ? t : t + "";
}
function h(r, t) {
  if (a(r) != "object" || !r) return r;
  var e = r[Symbol.toPrimitive];
  if (e !== void 0) {
    var n = e.call(r, t);
    if (a(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(r);
}
function j(r, t) {
  var e = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (e) return (e = e.call(r)).next.bind(e);
  if (Array.isArray(r) || (e = P(r)) || t) {
    e && (r = e);
    var n = 0;
    return function() {
      return n >= r.length ? { done: !0 } : { done: !1, value: r[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function P(r, t) {
  if (r) {
    if (typeof r == "string") return m(r, t);
    var e = {}.toString.call(r).slice(8, -1);
    return e === "Object" && r.constructor && (e = r.constructor.name), e === "Map" || e === "Set" ? Array.from(r) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? m(r, t) : void 0;
  }
}
function m(r, t) {
  (t == null || t > r.length) && (t = r.length);
  for (var e = 0, n = Array(t); e < t; e++) n[e] = r[e];
  return n;
}
function E(r, t) {
  var e = t.schema, n = t.getHeaderStyle, l = t.getStyle, b = t.getSharedString, p = t.customFont, s = t.dateFormat;
  if (e) {
    for (var c = [], g = j(e), f; !(f = g()).done; ) {
      var v = f.value;
      if (v.column) {
        c = [e.map(function(o) {
          return i({
            type: String,
            value: o.column,
            align: o.align
          }, n ? n(o) : w);
        })];
        break;
      }
    }
    r = c.concat(r.map(function(o) {
      return e.map(function(u) {
        return i(i(i({}, u), u.getCellStyle ? u.getCellStyle(o) : void 0), {}, {
          value: u.value(o)
        });
      });
    }));
  }
  return r.map(function(o, u) {
    return S(o, u, {
      getStyle: l,
      getSharedString: b,
      customFont: p,
      dateFormat: s,
      usesSchema: e !== void 0
    });
  }).join("");
}
var w = {
  fontWeight: "bold"
};
export {
  E as default
};
//# sourceMappingURL=index.es500.js.map
